<template>
	<div class="my-profile">
		<Nav />
		<span class="overlay" :class="{ active: isMenuOpen || isUpdatePasswordModalOpen || isUpdateProfileModalOpen }"></span>
		<div class="header header-standard">
			<HeaderNavBar back route="MyProfile" />
		</div><!-- header -->
		<div class="header-image grey"></div><!-- header image -->
		<div class="content-wrap content-wrap-alt content-wrap-nav">
			<SectionTitle
				icon="LoginIcon"
				subtitle="My Profile"
				title="Login Details"
				colour="profile profile-cyan"
			/>
            <div v-if="apple" class="section-gap text-block">
                <p class="no-space"><strong>Your profile is connected to Apple</strong></p>
                <p>Good news, you don’t need to worry about changing your email address or password, as your account is linked to your Apple profile.</p>
            </div>
            <div v-else-if="google" class="section-gap text-block">
                <p class="no-space"><strong>Your profile is connected to Google</strong></p>
                <p>Good news, you don’t need to worry about changing your email address or password, as your account is linked to your Google profile.</p>
            </div>
			<div v-else-if="facebook" class="section-gap text-block">
				<p class="no-space"><strong>Your profile is connected to Facebook</strong></p>
				<p>Good news, you don’t need to worry about changing your email address or password, as your account is linked to your Facebook profile.</p>
			</div>
			<form v-else class="form" @submit.prevent="">
				<div class="field" :class="{ 'field-error': $v.form.email.$error || errorStyling == true }">
					<label for="email-input" class="label">Email Address</label>
					<div class="control">
						<input id="email-input" class="input" type="email" placeholder="Enter your email address" v-model="form.email" @keydown.enter.prevent>
					</div>
				</div>
				<div class="field error" v-if="errorMessage">
					<span class="field-error-message">{{ errorMessage }}</span>
				</div>
				<div class="flex-bottom">
					<Button @click.native="$store.commit('UPDATE_PASSWORD_TOGGLE');" icon="KeyIcon" class="password-btn none-bottom btn btn-med btn-grey btn-tick btn-square btn-icon btn-icon-right" text="Change My Password"></Button>
					<Button @click.native="updateLoginDetails" icon="LoadingIcon" class="none-bottom btn btn-med btn-green btn-tick btn-square btn-icon btn-icon-right" text="Update Login Details"></Button>
					<a class="text-link" @click="archiveAccount">Disable my account &raquo;</a>
				</div><!-- flex bottom -->
			</form>
		</div>
        <UpdateProfileOverlay />
		<UpdatePasswordOverlay />
		<Menu />
	</div>
</template>
<script>
	import HeaderNavBar from '@/components/HeaderNavBar.vue';
	import Nav from '@/components/Nav.vue';
	import Button from '@/components/Button.vue';
	import Menu from '@/components/Menu.vue';
	import SectionTitle from '@/components/SectionTitle.vue';
	import UpdatePasswordOverlay from '@/components/UpdatePasswordOverlay.vue';
	import { required, email } from 'vuelidate/lib/validators';
    import UserService from '@/services/UserService';
    import UpdateProfileOverlay from '@/components/UpdateProfileOverlay.vue';
	export default {
		name: 'MyProfileLoginDetails',
		components: {
			Nav,
			HeaderNavBar,
			Menu,
			SectionTitle,
			Button,
			UpdatePasswordOverlay,
            UpdateProfileOverlay
		},
		data () {
	        return {
                facebook: false,
                google: false,
                apple: false,
	        	form: {
	        		email: '',
	        		password: '**********'
	        	},
                errorMessage: null,
                errorStyling: false
	        };
	    },
	    validations () {
	    	return {
	    		form: {
	            	email: {
						required,
                        email
					},
					password: {
						required
					}
	           	}
	    	};
	    },
	    methods: {
            getUser () {
                UserService.getUser().then((response) => {
                    this.facebook = response.data.facebook;
                    this.google = response.data.google;
                    this.apple = response.data.apple;
                    this.form.email = response.data.email;
                });
            },
            updateLoginDetails () {
                this.errorMessage = false;
                this.errorStyling = false;
                this.$v.form.$touch();
                if (!this.$v.form.$error) {
                    UserService.updateUser({
                        email: this.form.email
                    }).then(() => {
                        this.$store.commit('UPDATE_PROFILE_TOGGLE');
                    }).catch((error) => {
                        if (error.response.data.message) {
                            this.errorMessage = error.response.data.message;
                        }
                    });
                }
            },
            archiveAccount () {
                if (confirm('Are you sure you want to disable your account?')) {
                    UserService.archiveAccount().then(() => {
                        this.$router.push('/');
                    });
                }
            }
        },
	    computed: {
			isMenuOpen () {
	            return this.$store.state.isMenuOpen;
	        },
            isUpdatePasswordModalOpen () {
                return this.$store.state.isUpdatePasswordModalOpen;
            },
            isUpdateProfileModalOpen () {
                return this.$store.state.isUpdateProfileModalOpen;
            }
		},
		mounted () {
            this.getUser();
        }
	};
</script>
<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	.password-btn {
		margin-bottom: 50px;
	}
	.text-link {
		color: $mid;
	}
	.icon-lock {
		width: 18px;
    	height: auto;
		g, path {
			stroke-width: 4;
			stroke: $light!important;
		}
	}
	.section-title {
		&.red {
			color: #C83254;
		}
	}
	form {
		margin-top: 30px;
		margin-bottom: 100px;
		.field {
			margin-bottom: 25px;
		}
	}
</style>
